const ITEMS = [
  "100+ YEARS COMBINED CONSULTING LEGACY",
  "ZERO TO FUNDED, ON CAMPUS",
  "INVESTOR-READY PROTOTYPES",
  "FRANTIGER® NETWORK ACCESS",
  "A DECADE OF FRANTIGER®",
  "IDEATION → VALIDATION → FUNDING → GTM",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-8 text-lg sm:text-xl tracking-tight ${
            i % 2 === 0
              ? "font-serif-accent text-white"
              : "font-mono-x text-sm sm:text-base uppercase tracking-[0.25em] text-white/70"
          }`}
        >
          {item}
        </span>
        <span className="w-2 h-2 bg-white/80 rotate-45 shrink-0" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section data-testid="editorial-marquee" className="bg-[#0055FF] py-5 overflow-hidden border-y border-[#0043CC]">
    <div className="flex animate-marquee w-max">
      <Row />
      <Row />
    </div>
  </section>
);

export default Marquee;
